import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import Icon from 'flarum/common/components/Icon';
// fof/masquerade's field base class, patched when its bundle registers it.
const BASE_FIELD = 'ext:fof/masquerade/forum/types/BaseField';
/**
 * fof/masquerade's profile fields (styled in masquerade.less):
 * - one markup for a field everywhere: its icon, its name (no trailing
 *   colon) and the answer, with the name as a tooltip. On the profile tab
 *   that becomes a card; in the profile hero and directory cards a pill with
 *   just the icon and the answer;
 * - links to someone else's profile (avatars, names, user cards) open their
 *   Profile tab rather than their posts, when there is a profile to see.
 *   Their Posts tab is still one click away, and your own profile still
 *   opens on your posts.
 */
export default function masquerade() {
  override(BASE_FIELD, 'answerField', function () {
    if (app.forum.attribute('masquerade.hide-empty-fields') && !this.hasAnswer()) return null;
    const name = this.field.name();
    const icon = this.field.icon();
    return m("div", {
      className: 'Masquerade-Bio-Set' + (this.hasAnswer() ? '' : ' Masquerade-Bio-Set--empty'),
      title: name
    }, m("span", {
      className: "Masquerade-Bio-Field"
    }, icon && m(Icon, {
      name: icon
    }), m("span", {
      className: "Masquerade-Bio-Label"
    }, name)), m("span", {
      className: "Masquerade-Bio-Answer"
    }, this.answerContent()));
  });
  const userRoute = app.route.user;
  app.route.user = user => {
    const bioFields = user.bioFields?.();
    const hasNoProfile = Array.isArray(bioFields) && !bioFields.some(answer => answer?.content());
    if (!user || user === app.session.user || !app.forum.attribute('canViewMasquerade') || hasNoProfile) {
      return userRoute(user);
    }
    return app.route('fof-masquerade', {
      username: user.slug()
    });
  };
}